import {
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ClientsService } from '../services/clients/clients.service';
import { ApiConfigService } from '../../libs/api-contract/api-config.service';

@Injectable()
export class ClientHttpInterceptor implements HttpInterceptor {
    private readonly clientsService = inject(ClientsService);
    private readonly apiConfigService = inject(ApiConfigService);

    intercept(request: HttpRequest<unknown>, next: HttpHandler) {
        const activeClientId = this.clientsService.activeClientId;
        const apiBaseUrl = this.apiConfigService.get()?.apiBaseUrl;

        if (activeClientId && request.url.startsWith(apiBaseUrl)) {
            const clonedRequest = request.clone({
                setHeaders: {
                    'x-clmi-portalclient': activeClientId,
                },
            });
            return next.handle(clonedRequest);
        }

        return next.handle(request);
    }
}
